import ContentImage from "@/shared/ContentImage";
import Slider from "@/shared/Slider";
import { ContentSlider,HorizontalSlider } from "./style";
import { LinkAbsolute } from "@/shared/LinkAbsolute";
import ContentIcon from "@/shared/ContentIcon";
import { getImageByClippings } from "helpers";

const LatestSlider = ({ latest,title,iconName }) => {
  const slides = latest.map(({ name, thumbnail= "", url, title, images  }, index) => {
    let dataImage;
    if (thumbnail) {
      dataImage = {
        desktop: {
          image: thumbnail,
          height: 100,
          width: 100,
        },
        mobile: {
          image: thumbnail,
          height: 100,
          width: 100,
        }
      }
    }
    if (images) {
      dataImage = getImageByClippings(
        {
          desktop: ["16_9_medianas"],
          mobile: ["16_9_medianas"],
        },
        images?.[0]?.value?.clippings ?? []
      )
    }
    return (
      <div className="card" key={`itemLastestSlider${index}`}>
        <LinkAbsolute href={url} />
        <picture>
          <ContentImage
            data= {dataImage}
            alt={name}
          />
          {iconName && 
          <ContentIcon
              width="18px"
              height="18px"
              display="flex"
              nameIcon={iconName}
            />
          }
        </picture>
        <p>{name ? name : title}</p>
      </div>
    );
  });

  return (
    <HorizontalSlider>
      <p className="title-slider">{title}</p>
      <ContentSlider>
        <Slider
          items={slides}
          quantityPerItem={3}
          arrowLeft={" "}
          arrowRight={" "}
          previewNext={true}
          />
      </ContentSlider>
    </HorizontalSlider>
  );
};
export default LatestSlider;